module.exports = __webpack_public_path__ + "media/images/icon/icons8-Mind Map-1046018264b9da27e2c0fd39fa163316.png";